// extracted by mini-css-extract-plugin
module.exports = {"content":"colorable-simple-block-module--content--3sXjS"};